import React from "react";

const Modal = ({ children, isOpen, onClose, title, maxWidth }) => {
  // Support both old pattern (always show) and new pattern (controlled via isOpen)
  // If isOpen is provided, use it to control visibility. Otherwise, always show (backward compatible)
  if (isOpen !== undefined && !isOpen) {
    return null;
  }

  const panelMaxWidth = maxWidth != null ? maxWidth : "800px";

  // If onClose is NOT provided, render exactly as the original Modal (backward compatible)
  if (!onClose) {
    return (
      <>
        <div className="overlay"></div>
        <div
          style={{
            boxShadow: "0 0 20px rgab(0,0,0,1)",
            borderRadius: "20px",
            padding: "30px",
            paddingBottom: "13px",
          }}
          className="page-center box-shadow pl-16 pr-16 pb-16 pt-16 bg-white z-50 br-2 modal-overflow"
        >
          {children}
        </div>
      </>
    );
  }

  // New pattern: when onClose is provided, use enhanced Modal with close button and title
  return (
    <>
      <div 
        className="overlay"
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1000,
        }}
      ></div>
      <div
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          boxShadow: "0 0 20px rgba(0,0,0,0.3)",
          borderRadius: "20px",
          padding: "20px",
          backgroundColor: 'white',
          zIndex: 1001,
          width: '95vw',
          maxWidth: panelMaxWidth,
          maxHeight: '90vh',
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}
        className="br-2 modal-overflow"
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          type="button"
          aria-label="Close"
          style={{
            position: 'absolute',
            top: '15px',
            right: '15px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#6c757d',
            padding: '8px',
            borderRadius: '4px',
            transition: 'all 0.2s',
            zIndex: 10,
            width: '40px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = '#f8f9fa';
            e.target.style.color = '#333';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'none';
            e.target.style.color = '#6c757d';
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="currentColor"
            viewBox="0 0 16 16"
          >
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
          </svg>
        </button>

        {title && (
          <div style={{ 
            marginBottom: '20px', 
            borderBottom: '1px solid #eee', 
            paddingBottom: '10px',
            paddingRight: '50px'
          }}>
            <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>{title}</h2>
          </div>
        )}
        {children}
      </div>
    </>
  );
};

export default Modal;
